import React from 'react';
import { BsInstagram, BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs'
import { SubHeading } from '../../components';
import { images } from '../../constants';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';



const Gallery = () => {

  const scrollRef = React.useRef(null)

  const scroll = (direction) => {
    const { current } = scrollRef;

    if(direction === 'left') {
      current.scrollLeft -= 300;
    } else {
      current.scrollLeft += 300;
    }
  }

  const galleryImages = [images.gallery01, images.gallery02, images.gallery03, images.gallery04]

  return (
    <div className='app__gallery app__bg' id='gallery'>
      <div className='app__gallery-content' >
        <SubHeading title='Instagram' />
        <h1 className='headtext__cormorant' >Photo Gallery</h1>
        <p className='p__opensans' >A peek at the delightful sight of our famous dishes and cocktails.</p>
        <button type='button' className='custom__button' >View More</button>
      </div>
      <div className='app__gallery-images' >
        <div className='app__gallery-images_container' ref={scrollRef} >
          {
            galleryImages.map( (image, index) => {
              return (
              <div className='app__gallery-images_card' >
                <LazyLoadImage effect='blur' src={image} alt={`gallery${index}`} key={'image' + index} />
                <BsInstagram className='app__gallery_image-icon' />
              </div>
              )
            })
          }
        </div>
        <div className='app__gallery-images_arrows' >
          <BsArrowLeftShort className='app__gallery_arrow-icon' onClick={ () => scroll('left') } />
          <BsArrowRightShort className='app__gallery_arrow-icon' onClick={ () => scroll('right') } />
        </div>
      </div>
    </div>
  );
}

export default Gallery;
